(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_custom-newsletter-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('newsletter-form')) {
    class NewsletterForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.hasError = false;
        this.itiInitialized = false;

        this.klaviyoTarget = this.dataset.klaviyoTarget;
        this.attentiveTarget = this.dataset.attentiveTarget;

        this.telInput = this.querySelector('input[type="tel"]');
        this.mailInput = this.querySelector('input[type="email"]');
        this.errorMessage = this.querySelector('.newsletter__error');


        this.emptyError = this.querySelector('[data-empty-error]');

        this.addEventListener('submit', this.onFormSubmit.bind(this), {
          signal: this.abortController.signal,
        });

        this.addEventListener('change', this.fieldChange.bind(this), {
          signal: this.abortController.signal,
        });

        this.initPhonefield();
      }

      fieldChange() {
        this.classList.remove('newsletter--has-error');
      }

      initPhonefield() {
        if (!!window.intlTelInput) {
          this.itiInput = window.intlTelInput(this.querySelector('input[type="tel"]'), {
            separateDialCode: true,
            initialCountry: Shopify.country,
            loadUtils: () => import(window.intlTelInputUtils),
          });
          this.itiInitialized = true;
        } else {
          setTimeout(() => {
            this.initPhonefield.call(this);
          }, 300);
        }
      }

      async onFormSubmit(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        let klaviyoSubmission = null;
        let attentiveSubmission = null;

        this.validateFields();

        if (this.hasError) return;
        if (this.mailInput.value != '' && this.klaviyoTarget != '') {
          klaviyoSubmission = this.sendSubscriptionToKlaviyo({
            email: this.mailInput.value,
            sms: this.itiInput ? this.itiInput.getNumber() : this.telInput.value,
          });
        }

        if (this.telInput.value != '' && this.attentiveTarget != '') {
          attentiveSubmission = this.sendSubscriptionToAttentive({
            email: this.mailInput.value,
            sms: this.itiInput ? this.itiInput.getNumber() : this.telInput.value,
            attentiveTarget:  this.attentiveTarget
          });
        }

        try {
          await Promise.all([klaviyoSubmission, attentiveSubmission]).then((responses) => {
            let errorFound = false;

            responses.forEach((response) => {
              if(response && response.status != 200 && response.status != 202) {
                this.throwGenericError();
                errorFound = true;
              }
            })

            if(!errorFound) {
              this.throwSuccessMessage();
            }
          })
        } catch (error) {
          this.throwGenericError();
        }
      }

      throwGenericError() {
        this.errorMessage.innerText = 'An error has occurred please try again later';
        this.classList.toggle('newsletter--has-error', true);

        setTimeout(() => {
          this.classList.toggle('newsletter--has-error', false);
        }, 5000);
      }

      throwSuccessMessage() {
        this.classList.toggle('newsletter--success', true);
      }

      sendSubscriptionToKlaviyo({ email, sms }) {
        return fetch("https://a.klaviyo.com/client/subscriptions?company_id=KkSJyW", {
          method: "post",
          headers: {
            "revision": " 2026-04-15",
            "content-type": "application/vnd.api+json",
            "accept": "application/vnd.api+json"
          },
          body: JSON.stringify({
            "data": {
              "type": "subscription",
              "attributes": {
                "profile": {
                  "data": {
                    "type": "profile",
                    "attributes": {
                      "subscriptions": {
                        "email": {
                          "marketing": {
                            "consent": "SUBSCRIBED"
                          }
                        },
                        "sms": {
                          "marketing": {
                            "consent": "SUBSCRIBED"
                          },
                        },
                      },
                      "email": email,
                      "phone_number": sms
                    }
                  }
                },
                "custom_source": "Footer Newsletter Form"
              },
              "relationships": {
                "list": {
                  "data": {
                    "type": "list",
                    "id": this.klaviyoTarget,
                  }
                }
              }
            }
          })
        })
      }

      sendSubscriptionToAttentive({ email, sms, attentiveTarget }) {
        return fetch("https://hook.us1.make.com/sfdofl0c0be7u899sqw5onfog2gcp53j", {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            sms,
            email,
            attentiveTarget
          }),
        });
      }

      validateFields() {
        const fields = this.querySelectorAll('input');
        let allEmpty = true;
        let invalidField = false;

        if (this.mailInput.value != '' || this.telInput.value != '') {
          allEmpty = false;
        }

        if (allEmpty) {
          this.hasError = true;
          this.errorMessage.innerText = 'At least one field must be populated';
        }

        if (!allEmpty && this.itiInitialized && this.telInput.value != '' && !this.itiInput.isValidNumber()) {
          invalidField = true;
        }

        if (!allEmpty && invalidField) {
          this.hasError = true;
          this.errorMessage.innerText = 'The phone number does not match the country selected';
          return;
        }

        this.classList.toggle('newsletter--has-error', allEmpty || invalidField);

        this.hasError = allEmpty || invalidField;
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('newsletter-form', NewsletterForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_custom-reviews"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('custom-reviews')) {
  class CustomReviews extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.abortController = new AbortController();

      this.widgetInstance = this.querySelector('.yotpo-widget-instance');

      this.widgetInstance.addEventListener('click', this.onReviewsClick.bind(this));
      document.addEventListener('pdp:product-change', this.onProductChange.bind(this));
    }

    onReviewsClick(evt) {
      evt.preventDefault();

      if(evt.target.closest('.yotpo-star-rating-reviews-summary-link')) {
        document.querySelector('.yotpo-reviews-summary-button').click();
      }

      const mainWidget = document.querySelector('#yotpo-reviews-main-widget');

      if(mainWidget) {
        const stickyHeader = document.querySelector('sticky-header');
        mainWidget.style.scrollMargin = stickyHeader.offsetHeight + "px";
        mainWidget.scrollIntoView({
          block: "start",
          behavior: "smooth",
        })
      }
    }

    onProductChange(evt) {
      const product = evt.detail.product;

      if(product) {
        const mainWidget = document.querySelector('[data-yotpo-instance-id="1222381"]');
        this.widgetInstance.setAttribute('data-yotpo-product-id', product.id);

        if(mainWidget) {
          mainWidget.setAttribute('data-yotpo-product-id', product.id);
          mainWidget.setAttribute('data-yotpo-url', document.location.host + product.url);
          mainWidget.setAttribute('data-yotpo-image-url', product.featured_image);
          mainWidget.setAttribute('data-yotpo-price', product.price / 100);

        }
      }
      yotpoWidgetsContainer.initWidgets();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }
  }

  customElements.define('custom-reviews', CustomReviews);
 }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-added-value"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-added-values')){
    class ProductAddedValues extends HTMLElement {
      constructor() {
        super ();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.referrer = null;
        this.togglerButtons = this.querySelectorAll('[data-modal-toggler]');
        this.modal = this.querySelector('[data-values-modal]');
        this.modalContent = this.querySelector('[data-modal-content]');
        this.modalClose = this.querySelector('.added-values__modal-close')
        this.dynamicFreeShippingThreshold = this.querySelector('[data-dynamic-shipping]');
        this.mutationObserver = new MutationObserver(this.freeGiftObserverCallback.bind(this));

        this.togglerButtons.forEach(button => {
          button.addEventListener('click', this.openModal.bind(this), {
            signal: this.abortController.signal
          })

          this.modalClose.addEventListener('click', this.closeModal.bind(this), {
            signal: this.abortController.signal
          })
        })

        if(this.dynamicFreeShippingThreshold) {
          const shippingContainer = document.getElementById('GlobaleFreeShippingBannerContainer');
          this.mutationObserver.observe(shippingContainer, {
            childList: true,
            subtree: true,
          })
        }
      }

      openModal(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const contentType = `[data-${evt.target.dataset.modalToggler}-content]`;
        const contentObject = this.querySelector(contentType);

        if(contentObject) {
          const modalContent = contentObject.content.cloneNode(true);
          this.modalContent.replaceChildren(modalContent);

          this.modal.showModal();
          setTimeout(() => {
            this.modalContent.scroll({top: 0})
          }, 10);

          Shopify.trapFocus(this.modal)
        }
      }

      closeModal(evt) {
        this.modal.close();
        Shopify.removeTrapFocus(this.referrer);
      }

      freeGiftObserverCallback(entries) {
        const self = this;
        entries.forEach(entry => {
          const content = entry.addedNodes[0].querySelector('#FreeShippingBanner').innerText.split(' ');

          this.dynamicFreeShippingThreshold.innerText = content.at(-1).replace('.00', '');
        })
      }

      checkFreeGiftThreshold() {

      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
    customElements.define('product-added-values', ProductAddedValues)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-atc"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-atc')) {
    class ProductAtc extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.productForm = this.closest('product-form');
        const variantEl = this.productForm.querySelector('[name="id"]');
        const productJsonEl = this.productForm.querySelector('[data-product-json]');

        if(!variantEl || !productJsonEl) return;

        const variantId = variantEl.value;
        const productJson = JSON.parse(productJsonEl.innerHTML);

        this.atcButton = this.querySelector('#product__atc-button');
        this.bisButton = this.querySelector('#product__bis-button');
        this.variant = productJson.variants.find((variant) => variant.id == variantId);

        this.productForm.addEventListener('pdp:variant-change', this.onVariantChange.bind(this), {
          signal: this.abortController.signal
        })

        this.atcButton.addEventListener('click', this.onAtcButtonClick.bind(this), {
          signal: this.abortController.signal
        })

        if(this.bisButton) {
          this.bisButton.addEventListener('click', this.onBisClick.bind(this), {
            signal: this.abortController.signal
          })
        }

        this.onVariantChange({
          detail: {
            variant: this.variant
          }
        })
      }

      onAtcButtonClick(evt) {
        const selectedOptions = Array.from(this.productForm.querySelectorAll('[data-current-value]'));
        const selectedOptionsValues = selectedOptions.filter(option => option.innerText.trim() != '');
        const completeSelection = selectedOptions.length == selectedOptionsValues.length;

        if(!completeSelection) {
          console.log('this should trigger an error');
          evt.preventDefault();

          const emptyOption = selectedOptions.find(option => option.innerText.trim() == '');
          emptyOption.dispatchEvent(new CustomEvent('product-option:error', {
            bubbles: true
          }));
        }
      }

      onVariantChange(evt) {
        this.variant = evt.detail.variant;
        const selectedOptions = Array.from(this.productForm.querySelectorAll('[data-current-value]'));
        const selectedOptionsValues = selectedOptions.filter(option => option.innerText.trim() != "");
        const hasFullSelection = selectedOptionsValues.length == selectedOptions.length;

        if(!hasFullSelection) {
          return;
        }

        if(!this.variant) {
          if(this.bisButton) {
            this.bisButton.classList.add('hidden');
          }
          this.atcButton.disabled = true;
          this.atcButton.innerText = window.variantStrings.unavailable;
          return;
        }

        if(!this.variant.available) {
          if(this.bisButton) {
            this.bisButton.classList.remove('hidden');
          }
          this.atcButton.setAttribute('disabled', true)
          this.atcButton.innerText = window.variantStrings.soldOut;
          return;
        }

        if(this.bisButton) {
          this.bisButton.classList.add('hidden');
        }
        this.atcButton.removeAttribute('disabled');
        this.atcButton.innerText = window.variantStrings.addToCart;
      }

      onBisClick(evt) {
        document.dispatchEvent(new CustomEvent('bisForm:open', {
          detail: {
            productTitle: this.variant.product_title,
            variantTitle: this.variant.title,
            variantId: this.variant.id,
          },
          bubbles: true
        }))
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('product-atc', ProductAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-badges"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-badges')) {
    class ProductBadges extends HTMLElement {
      constructor() {
        super();
        this.currentProduct;
        this.currentVariant;
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.productContainer = document.querySelector('[data-product-container]');
        const variantEl = this.productContainer.querySelector('[name="id"]');
        const productJsonEl = this.productContainer.querySelector('[data-product-json]')

        if(!variantEl || !productJsonEl) return;

        const variantId = variantEl.value;
        this.currentProduct = JSON.parse(productJsonEl.innerHTML);
        this.currentVariant = this.currentProduct.variants.find((variant) => variant.id == variantId);


        this.closest('[data-product-container]').addEventListener('pdp:product-change', this.onProductChange.bind(this), {
          signal: this.abortController.signal
        });

        this.closest('[data-product-container]').addEventListener('pdp:variant-change', this.onVariantChange.bind(this), {
          signal: this.abortController.signal
        });

        this.updateBadges();
      }

      onProductChange(evt) {
        this.currentProduct = evt.detail.product;
        this.updateBadges();
      }

      onVariantChange(evt) {
        this.currentVariant = evt.detail.variant;
        this.updateBadges();
      }

      updateBadges() {
        let badgeList = [];
        const selectedOptions = Array.from(this.productContainer.querySelectorAll('[data-current-value]'));
        const selectedOptionsValues = selectedOptions.filter(option => option.innerText.trim() != '');
        const completeSelection = selectedOptions.length == selectedOptionsValues.length;

        this.currentProduct?.tags?.forEach(tag => {
          if(tag.includes('badge:')) {
            badgeList.push(tag.replace('badge:', '').replace('collection_', ''))
          }
        })

        if(this.currentVariant?.compare_at_price > this.currentVariant?.price) {
          if(this.currentProduct?.title.includes('- FINAL SALE')) {
            badgeList.push('Final Sale')
          } else {
            badgeList.push('Sale');
          }
        }

        if(completeSelection && !this.currentVariant) {
          badgeList.push(window.variantStrings.unavailable);
        }

        if(this.currentVariant && !this.currentVariant?.available) {
          badgeList.push(window.variantStrings.soldOut);
        }

        badgeList = badgeList.map((badge) => {
          return `<span class="badge caption">${badge}</span>`
        })

        this.innerHTML = badgeList.join('');
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('product-badges', ProductBadges);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-bundle-message"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bundle-message')) {

    class BundleMessage extends HTMLElement {
      constructor() {
        super();
        this.bundleMessages = window.bundle_messages;
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.bundleMessage = this.querySelector('[data-bundle-message]');
        const productInfo = this.closest('.product__info-block').querySelector('[data-product-json]').innerHTML;

        document.addEventListener('pdp:product-change', this.onProductChange.bind(this));


        if(productInfo) {
          const productJson = JSON.parse(productInfo);

          this.onProductChange({
            detail : {
              product: productJson
            }
          })
        }
      }

      onProductChange(evt) {
        const product = evt.detail.product;

        const messageObject = this.bundleMessages.find((messageObject) => {
          const hasCollection = messageObject.applicable_collection.some((loopCollection) => {
            return product.collections.includes((loopCollection));
          })

          const hasProduct = messageObject.applicable_product.some((loopProduct) => product.id === loopProduct);

          return hasCollection || hasProduct;
        })

        if(messageObject) {
          this.bundleMessage.innerText = messageObject.message;
          this.bundleMessage.classList.remove('hidden');
        } else {
          this.bundleMessage.classList.add('hidden');
          this.bundleMessage.innerText = "";
        }

      }


      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('bundle-message', BundleMessage)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-info"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-info')) {

    class ProductInfo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.tabsContainer = this.querySelector('.product-info__tablist');
        this.tabs = Array.from(this.tabsContainer.querySelectorAll('.product-info__tab-btn'));
        this.panels = Array.from(this.querySelectorAll('.product-info__tab-panel'));
        this.howWhereBtns = Array.from(this.querySelectorAll('[data-how-where-button]'))
        this.howWhereModal = this.querySelector('[data-how-where-modal]');
        this.howWhereCloseBtn = this.querySelector('[data-how-where-modal-close]');
        this.sizeGuideBtn = this.querySelector('[data-size-guide-btn]');

        this.tabsContainer.addEventListener('keydown', this.onKeyInteraction.bind(this), {
          signal: this.abortController.signal
        })

        this.tabsContainer.addEventListener('click', this.onButtonClick.bind(this), {
          signal: this.abortController.signal
        })

        if(this.howWhereBtns.length > 0) {
          this.howWhereBtns.forEach((button) => {
            button.addEventListener('click', this.onHowWhereClick.bind(this), {
              signal:this.abortController.signal
            })
          })

          this.howWhereCloseBtn.addEventListener('click', this.onHowWhereClose.bind(this), {
            signal: this.abortController.signal
          })

          this.howWhereModal.addEventListener('click', this.onModalClick.bind(this), {
            signal: this.abortController.signal
          })
        }

        if(this.sizeGuideBtn) {
          this.sizeGuideBtn.addEventListener('click', this.onSizeGuideBtnClick.bind(this), {
            signal: this.abortController.signal
          })
        }
      }

      onKeyInteraction(evt) {
        if(evt.key == "End"){
          this.tabs[this.tabs.length - 1].focus();
          evt.preventDefault();
        }

        if(evt.key == "Home") {
          this.tabs[0].focus();
          evt.preventDefault();
        }

        if(evt.key == "ArrowLeft") {
          const activeButton = document.activeElement;

          const currentTabIndex = this.tabs.findIndex(tab => tab == activeButton);

          if(currentTabIndex == 0) {
            this.tabs[this.tabs.length - 1].focus()
          } else {
            this.tabs[currentTabIndex - 1].focus();
          }
        }

        if(evt.key == "ArrowRight") {
          const activeButton = document.activeElement;

          const currentTabIndex = this.tabs.findIndex(tab => tab == activeButton);

          if(currentTabIndex == this.tabs.length - 1) {
            this.tabs[0].focus()
          } else {
            this.tabs[currentTabIndex + 1].focus();
          }
        }
      }

      onButtonClick(evt) {
        evt.preventDefault();

        if(evt.target.tagName == "BUTTON") {
          const targetPanel = evt.target.getAttribute('aria-controls');

          this.tabs.forEach(tab => {
            if(tab !== evt.target) {
              tab.setAttribute('aria-selected', false);
            } else {
              tab.setAttribute('aria-selected', true);
            }
          })

          this.panels.forEach(panel => {
            if(panel.id === targetPanel) {
              panel.classList.remove('hidden');
            } else {
              panel.classList.add('hidden');
            }
          })
        }

      }

      onHowWhereClick(evt) {
        const target = evt.currentTarget;
        const modalInfo = JSON.parse(target.dataset.modalInfo);
        const modalLink = this.howWhereModal.querySelector('[data-dialog-link]');
        const modalSubtitle = this.howWhereModal.querySelector('[data-dialog-subtitle]');

        this.focusTarget = target;
        this.howWhereModal.querySelector('[data-dialog-image]').src = modalInfo.image;
        this.howWhereModal.querySelector('[data-dialog-image]').alt = modalInfo.alt;
        this.howWhereModal.querySelector('[data-dialog-title]').innerText = modalInfo.title;
        this.howWhereModal.querySelector('[data-dialog-description]').innerHTML = modalInfo.description;

        if(modalInfo.subtitle) {
          modalSubtitle.innerText = modalInfo.subtitle;
          modalSubtitle.classList.remove('hidden');
        } else {
          modalSubtitle.classList.add('hidden');
        }

        if(modalInfo.link) {
          modalLink.href = modalInfo.link;
          modalLink.classList.remove('hidden');
        } else {
          modalLink.classList.add('hidden');
        }

        toggleBodyLock(this.howWhereModal, true);
        this.howWhereModal.showModal();

        window.Shopify.trapFocus(this.howWhereModal);
      }

      onSizeGuideBtnClick(evt) {
        evt.target.dispatchEvent(new CustomEvent('size-guide:open'), {
          signal: this.abortController.signal,
          bubbles: true,
        })
      }

      onHowWhereClose() {
        toggleBodyLock(this.howWhereModal, false);
        this.howWhereModal.close();
        window.Shopify.removeTrapFocus(this.focusTarget);
      }

      onModalClick(evt) {
        if(evt.target == this.howWhereModal) {
          this.onHowWhereClose();
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('product-info', ProductInfo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-redirection"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-redirection')) {
    class ProductRedirection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const currentReferenceValue = this.querySelector('[data-current-value]');
        const currentItem = this.querySelector('li.current');

        currentReferenceValue.innerText = currentItem.innerText;
      }
    }
    customElements.define('product-redirection', ProductRedirection);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-shop-the-look"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('shop-the-look')) {

  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.abortController = new AbortController();
      this.sliderContainer = this.querySelector('[data-slider]');

      if(!this.sliderContainer) return;

      if(this.sliderContainer.children.length > 0) {
        this.slider = new tns({
          container: this.sliderContainer,
          "autoWidth": false,
          "items": "1.5",
          "mouseDrag": true,
          "swipeAngle": 30,
          "speed": 400,
          "loop": false,
          "gutter": 25,
          "nav": false,
          "responsive": {
            750: {
              items: "2.5"
            }
          }
        })

        this.slider.events.on('transitionEnd', (info) => {
          const items = info.slideItems;
          items.forEach(item => {
            if(item.getAttribute('tabindex') === '-1') {
              item.setAttribute('inert', true);
            } else {
              item.removeAttribute('inert');
            }
          })
        })
      }
    }

    disconnectedCallback() {
      this.slider.destroy();
      this.abortController.abort();
    }
  }

  !customElements.define('shop-the-look', ShopTheLook)
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('size-guide')) {
    class SizeGuide extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback(){
        this.abortController = new AbortController();

        this.sizeGuideToggler = document.querySelectorAll('[data-size-guide-toggler]')
        this.sizeGuideModal = this.querySelector('[data-size-guide-modal]');

        if(!this.sizeGuideModal) {
          if(this.sizeGuideToggler.length > 0) {
            this.sizeGuideToggler.forEach((button) => {
              button.remove();
            })
          }
        } else {
          this.sizeGuideModal.querySelector('.size-guide__close-button').addEventListener('click', () => {
            this.sizeGuideModal.close();
          }, {
            signal: this.abortController.signal
          })

          if(this.sizeGuideToggler.length > 0) {
            this.sizeGuideToggler.forEach((button) => {
              button.addEventListener('click', this.openSizeGuideModal.bind(this), {
                signal: this.abortController.signal
              })
            })
          }
        }
      }

      openSizeGuideModal(evt) {
        this.trapFocusTarget = evt.currentTarget;
        this.sizeGuideModal.showModal();
        Shopify.trapFocus(this.sizeGuideModal);
      }

      closeSizeGuideModal() {
        this.sizeGuideModal.close();
        Shopify.removeTrapFocus(this.trapFocusTarget);
      }

      disconnectedCallback(){
        this.abortController.abort();
      }
    }
    customElements.define('size-guide', SizeGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-small-card"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('small-card')) {
    class SmallCard extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.form = this.querySelector('form');
        this.productInfo = JSON.parse(this.querySelector('[data-product-json]').innerHTML);
        this.priceContainer = this.querySelector('product-price');
        this.variantIdInput = this.form.querySelector('input[name="id"]');
        this.colorLabel = this.querySelector('.small-card__color');

        this.form.addEventListener('change', this.onOptionChange.bind(this), {
          signal: this.abortController.signal
        });

        this.addEventListener('pdp:variant-change', (evt) => evt.stopPropagation(), {
          signal: this.abortController.signal
        });

        this.form.addEventListener('submit', this.onFormSubmit.bind(this), {
          signal: this.abortController.signal
        });

        this.updateVariant();
        this.updateOptionAvailability();
        this.initStoreObject();
      }

      initStoreObject() {
        if (window.store && !this.store) {
          this.store = window.store;
        } else {
          setTimeout(() => {
            this.initStoreObject();
          }, 500);
        }
      }

      onFormSubmit(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const id = this.variantIdInput.value;

        store.dispatch('addItems', {
          [id]:1,
        }, true);
      }

      onOptionChange() {
        this.updateVariant();
      }

      updateVariant() {
        const selectedOptions = this.getSelectedOptions();
        const matchingVariant = this.productInfo.variants.find((variant) => {
          return variant.options.every((optionValue, index) => {
            return selectedOptions[index] === optionValue;
          });
        });

        this.currentVariant = matchingVariant || null;
        this.updateVariantInput();
        this.updateColorLabel(selectedOptions);
        this.updateOptionAvailability();

        this.priceContainer.dispatchEvent(new CustomEvent('pdp:variant-change', {
          detail: {
            variant: this.currentVariant
          }
        }));
      }

      getSelectedOptions() {
        return this.productInfo.options.map((option, index) => {
          const fieldName = `option${index + 1}`;
          const select = this.form.querySelector(`[name="${fieldName}"]`);
          const hidden = this.form.querySelector(`input[name="${fieldName}"]`);

          if (select) {
            return select.value;
          }

          if (hidden) {
            return hidden.value;
          }

          const firstVariant = this.productInfo.variants?.[0];
          return firstVariant?.options?.[index] || '';
        });
      }

      updateVariantInput() {
        if (!this.variantIdInput) return;

        if (this.currentVariant) {
          this.variantIdInput.value = this.currentVariant.id;
        } else {
          this.variantIdInput.value = '';
        }
      }

      updateOptionAvailability() {
        const selectedOptions = this.getSelectedOptions();
        const selects = Array.from(this.form.querySelectorAll('select'));

        selects.forEach((select) => {
          Array.from(select.options).forEach((option) => {
            const candidateOptions = selectedOptions.slice();
            const optionIndex = select.name.replace('option', '') - 1;
            candidateOptions[optionIndex] = option.value;

            const matchingVariant = this.productInfo.variants.find((variant) => {
              return variant.options.every((optionValue, index) => {
                return candidateOptions[index] === optionValue;
              });
            });

            if (!matchingVariant || matchingVariant.available === false || matchingVariant.available === 'false') {
              option.disabled = true;
            } else {
              option.removeAttribute('disabled');
            }
          });
        });
      }

      updateColorLabel(selectedOptions) {
        if (!this.colorLabel) return;

        const colorOptionIndex = this.productInfo.options.findIndex((option) =>
          option.name.toLowerCase() === 'color'
        );

        if (colorOptionIndex === -1) return;

        this.colorLabel.textContent = `Color: ${selectedOptions[colorOptionIndex]}`;
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('small-card', SmallCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-sticky-atc"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sticky-atc')) {
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.atcForm = document.querySelector("product-form form");
        this.header = document.querySelector('sticky-header');
        this.formButton = this.querySelector('[data-form-button]');
        this.body = document.querySelector('body');
        this.productImage = this.querySelector('[data-product-image]');

        if(this.atcForm) {
          this.intersectionObserver = new IntersectionObserver(this.observerCallback.bind(this), {
            rootMargin: `${-this.header.offsetHeight}px 0px 0px 0px`,
            threshold: [0, 0.01, 0.02, 0.1, 0.2, 0.3, 0.4],
            trackVisbility: true,
          })
          this.formButton.addEventListener('click', this.onFormButtonClick.bind(this), {
            signal: this.abortController.signal
          })
          this.intersectionObserver.observe(this.atcForm);
        }

        document.addEventListener('pdp:product-change', this.onProductChange.bind(this), {
          signal: this.abortController.signal
        })
      }

      onProductChange(evt) {
        const product = evt.detail.product;
        const sizes = [20, 28, 48, 85, 90, 112, 256, 320, 360, 480, 640, 750, 828, 1080, 1200, 1920, 2048, 3840];
        const srcset = sizes.map((size) => `${product.images[0].url} ${size}w`)

        this.productImage.src = product.images[0].url;
        this.productImage.srcset = srcset.join(',');
        this.productImage.alt = product.images[0].alt;
      }

      onFormButtonClick(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.atcForm.style.scrollMarginTop = this.header.offsetHeight + 10 + 'px';

        this.atcForm.scrollIntoView({
          block: "start",
          behavior: "smooth"
        })

        this.atcForm.querySelector('input[type="radio"]:checked').focus({preventScroll: true});
      }

      observerCallback(entries) {
        this.body.style.setProperty('--sticky-height', -this.scrollHeight + 'px');

        entries.forEach(entry => {
          if(!entry.isIntersecting && entry.boundingClientRect.bottom <= this.header.offsetHeight) {
            this.body.classList.add('sticky-cta-visible');
            this.toggleOsanoButton(true);
          } else {
            this.body.classList.remove('sticky-cta-visible');
            this.toggleOsanoButton(false);
          }
        })
      }

      toggleOsanoButton(hideButton) {
        const osanoButton = document.querySelector('.osano-cm-widget');
        if(osanoButton) {
          if(hideButton) {
            document.querySelector('.osano-cm-widget').style.opacity = 0;
          } else {
            document.querySelector('.osano-cm-widget').style.removeProperty('opacity');
          }
        } else {
          setTimeout(() => {
            this.toggleOsanoButton(hideButton);
          }, 100);
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
    customElements.define('sticky-atc', StickyAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-title"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-title')) {
    class ProductTitle extends HTMLElement {
      constructor() {
        super();
        this.abortController = new AbortController();
      }

      connectedCallback() {
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('product-title', ProductTitle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-wonderment-edd"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('wonderment-edd')) {
    class WondermentEdd extends HTMLElement {
      constructor() {
        super();
        this.API_BASE_URL = '/apps/wonderment';
        this.ZIP_LOCAL_STORAGE_KEY = 'wonderment-pdp-eta-zip';

        this.etaTextFontSize = '12px';
        this.querySelector('#wonderment-pdp-eta').style.fontSize = this.etaTextFontSize;

        this.hintTextFontSize = '10px';
        this.querySelector('#wonderment-zip-code-picker-error-text').style.fontSize = this.hintTextFontSize;

        this.isModalOpen = false;
        this.addedZipCodePickerListener = false;

        this.cachedZip = localStorage.getItem(this.ZIP_LOCAL_STORAGE_KEY);
        this.productID = this.dataset.productId;
        this.isAvailable = this.dataset.productAvailable;
      }

      connectedCallback() {
        this.container = this.children[0];
        this._controller = new AbortController();

        const self = this;

        this.querySelector("#wonderment-zip-code-picker-save-button")
        .addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const newZip = self.querySelector("#wonderment-zip-code-picker-zip-code-input").value;

          self.handleNewZip(newZip);
        }, {signal: this._controller.signal});

        this.querySelector("#wonderment-zip-code-picker-zip-code-input")
        .addEventListener("keydown", (e) => {
          const currZip = self.querySelector("#wonderment-zip-code-picker-zip-code-input").value;

          if (e.key === "Enter") {
            self.handleNewZip(currZip);
          } else if (e.key !== "Backspace" && (isNaN(e.key) || currZip.length >= 5)) {
            self.handleNewZip(currZip)
          }
        }, {signal: this._controller.signal});
        this.querySelector('#wonderment-zip-code-picker-zip-code-input').addEventListener('keyup', (e) => {
          const currZip = self.querySelector("#wonderment-zip-code-picker-zip-code-input").value;
          const submitButton = self.querySelector('#wonderment-zip-code-picker-save-button');
          if(currZip.length >= 5) {
            submitButton.removeAttribute('disabled');
          } else {
            submitButton.setAttribute('disabled', true);
          }
        }, {signal: this._controller.signal})

        this.querySelector('#wonderment-pdp-toggle-button').addEventListener('click', this.togglePickerOpen.bind(this), {
          signal: this._controller.signal
        });

        document.addEventListener('pdp:product-change', this.updateProductReference.bind(this), {
          signal: this._controller.signal
        })
        this.updateEta(this.cachedZip);
      }

      updateProductReference(evt) {
        const product = evt.detail.product;
        this.dataset.productId = product.id;
        this.productID = product.id;

        this.updateEta(localStorage.getItem(this.ZIP_LOCAL_STORAGE_KEY));
      }

      disconnectedCallback() {
        this._controller.abort();
        this.addedZipCodePickerListener = false;
      }

      updateEta(overrideZip) {
        fetch(`${this.API_BASE_URL}/etas/pdp?product_id=${this.productID}&is_available=${this.isAvailable}&cached_zip=${overrideZip || ''}`)
          .then(response => response.json())
          .then(json => {
            const {zip, iconUrl, hintText, etaTextTemplate, minDate, maxDate, estimatedDate} = json;

            let etaText = etaTextTemplate;
            etaText = etaText.replaceAll(
              "{min_date}",
              `<span style="font-weight: bold; display: inline-block">${minDate}</span>`
            );
            etaText = etaText.replaceAll(
              "{max_date}",
              `<span style="font-weight: bold; display: inline-block">${maxDate}</span>`
            );
            etaText = etaText.replaceAll(
              "{zip_code}",
              `<span id="wonderment-zip-code-picker-text">${zip}</span>`
            );

            etaText = etaText.replaceAll("{estimated_date}", `<span style="font-weight: bold; display: inline-block">${estimatedDate}</span>`)

            this.querySelector("#wonderment-pdp-eta-eta-text").innerHTML = etaText;
            this.querySelector("#wonderment-pdp-eta-hint-text").innerHTML = hintText;

            // Need to add event listener again
            this.addedZipCodePickerListener = false;
        })
      }

      togglePickerOpen() {
        this.isModalOpen = !this.isModalOpen;
        this.querySelector(".wonderment-pdp-info-container").style.display = !this.isModalOpen ? "block" : "none";
        this.querySelector("#wonderment-zip-code-picker-parent-wrapper").style.display = this.isModalOpen ? "block" : "none";
        this.querySelector("#wonderment-zip-code-picker-zip-code-input").focus();
      }

      handleNewZip(newZip) {
        if (newZip.length === 5) {
          // Set new zip
          this.querySelector("#wonderment-zip-code-picker-text").innerHTML =
            newZip;

          // Hide picker
          this.togglePickerOpen();

          // Clear error
          this.querySelector("#wonderment-zip-code-picker-error-text").style.display = "none";

          // Update local storage cache
          localStorage.setItem(this.ZIP_LOCAL_STORAGE_KEY, newZip);

          // Clear input
          this.querySelector("#wonderment-zip-code-picker-zip-code-input").value = "";

          // Reset Button State
          this.querySelector('#wonderment-zip-code-picker-save-button').setAttribute('disabled', true);

          // Call API to get new ETA
          this.updateEta(newZip)
        } else {
          document.querySelector("#wonderment-zip-code-picker-error-text").style.display = "block";
        }
      }
    }

    customElements.define('wonderment-edd', WondermentEdd);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_quick-view-atc"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('quick-view-atc')) {
    class QuickViewAtc extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.infoContainer = this.closest('.modal-window__inner');
        this.button = this.querySelector('[data-quick-view-atc-btn]')

        this.regularAtc = this.infoContainer.querySelector('product-form button[type="submit"]');
        this.intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback.bind(this), {
          root: this.infoContainer,
          rootMargin: "0px",
          threshold: [0, 0.1, 0.02],
        });
        if(this.regularAtc) {
          this.intersectionObserver.observe(this.regularAtc);
        }

        this.button.addEventListener('click', this.onButtonClick.bind(this));
      }

      onButtonClick(evt) {
        evt.stopPropagation();

        this.infoContainer.scrollTo({
          top: 0,
          behavior: "smooth"
        })
      }

      intersectionObserverCallback(entries) {
        const self = this;
        entries.forEach((entry) => {
          if(!entry.isIntersecting) {
            self.classList.add('visible');
          } else {
            self.classList.remove('visible');
          }
        })
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('quick-view-atc', QuickViewAtc)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_quick-view-read-more"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('quick-view-read-more')) {
    class QuickViewReadMore extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.quickView = this.closest('quick-view');

        this.quickView.addEventListener('pdp:product-change', this.onProductChange.bind(this), {
          signal: this.abortController.signal
        });

        this.quickView.addEventListener('pdp:variant-change', this.onVariantChange.bind(this), {
          signal: this.abortController.signal
        });

        this.addEventListener('read-more:url-change', this.onUrlChange.bind(this), {
          signal: this.abortController.signal
        });
      }

      onProductChange(evt) {
        const product = evt.detail.product;
        this.product = product;
        this.link = this.querySelector('[data-link]')

        const url = new URL(this.link.href);

        url.pathname = product.url;
        this.dispatchEvent(new CustomEvent('read-more:url-change',
          {
            detail: {
              url
            }
          }
        ), { bubbles: true });
      }

      onVariantChange(evt) {
        const variant = evt.detail.variant;

        if(!variant) return;

        this.variant = variant;
        this.link = this.querySelector('[data-link]')

        const url = new URL(this.link.href);

        url.searchParams.set('variant', variant.id);

        this.dispatchEvent(new CustomEvent('read-more:url-change',
          {
            detail: {
              url
            }
          }
        ), { bubbles: true })
      }

      onUrlChange(evt) {
        this.link.href = evt.detail.url.toString();
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('quick-view-read-more', QuickViewReadMore);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_tiered-cart-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tiered-cart-message')) {
    class TieredCartMessage extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.tierEls = Array.from(this.querySelectorAll('.cart__price-message'));
        this.tierBar = this.querySelector('[data-tier-bar]');
        this.cartPrice = this.dataset.cartPrice;

        this.processTiers();
        this.setProgress();

        this.tierBar.addEventListener('click', this.tierSelected.bind(this), {
          signal: this.abortController.signal,
        });

        this.addEventListener('keyup', this.keyup.bind(this), {
          signal: this.abortController.signal,
        });

        this.addEventListener('mouseleave', this.mouseLeave.bind(this), {
          signal: this.abortController.signal,
        })
      }

      processTiers() {
        this.maxThreshold = Math.max(...this.tierEls.map((item) => item.dataset.threshold));

        const tierBtns = this.tierEls.map((tier) => {
          const tierPosition = (tier.dataset.threshold * 100) / this.maxThreshold;
          return `
          <button
            type="button"
            class="cart__price-range-btn ${
              tier.classList.contains('cart__price-message--completed') ? 'cart__price-range-btn--completed' : ''
            }"
            aria-label="View Tier Info"
            style="--tier-position: ${tierPosition}%"
            data-toggle-tier="${tier.id}"
          >
            ${
              tier.classList.contains('cart__price-message--completed')
                ? `
              <svg class="icon icon-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none" aria-label="checkmark">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/>
              </svg>
            `
                : ''
            }
          </button>
        `;
        });

        this.tierBar.innerHTML = tierBtns.join('');
      }

      setProgress() {
        const progress = Math.min((this.cartPrice * 100) / this.maxThreshold, 100);
        this.style.setProperty('--bar-progress', progress + '%');

        this.tierBar.setAttribute('aria-valuenow', progress);
      }

      tierSelected(evt) {
        const tierId = evt.srcElement.dataset.toggleTier;

        this.tierEls.forEach((tier) => {
          if (tier.id == tierId) {
            tier.classList.toggle('cart__price-message--show', true);
            tier.classList.toggle('cart__price-message--hidden', false);
          } else {
            tier.classList.toggle('cart__price-message--show', false);
            tier.classList.toggle('cart__price-message--hidden', true);
          }
        });
      }

      keyup(evt) {
        if (evt.key == 'Escape') {
          evt.preventDefault();
          evt.stopPropagation();
          this.clearTierVisibility();
        }
      }

      mouseLeave() {
        setTimeout(() => {
          this.clearTierVisibility();
        }, 1000);
      }

      clearTierVisibility() {
        this.tierEls.forEach((tier) => {
          tier.classList.toggle('cart__price-message--show', false);
          tier.classList.toggle('cart__price-message--hidden', false);
        })
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
    customElements.define('tiered-cart-message', TieredCartMessage);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["full-width-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('full-width-media')) {
    class FullWidthMedia extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.io = new IntersectionObserver(this.observerCallback.bind(this), {
          rootMargin: '50px',
        });
        this.matchMedia = window.matchMedia('(max-width: 992px)');

        this.video = this.querySelector('video');

        if (this.video) {
          this.io.observe(this.video);
          this.matchMedia.addEventListener(
            'change',
            () => {
              this.video.load();
              if (this.video.autoplay) {
                this.video.play();
              }
            },
            {
              signal: this.abortController.signal,
            }
          );
        }
      }

      observerCallback(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.video.autoplay) {
              this.video.play();
            }
          } else {
            this.video.pause();
          }
        });
      }

      disconnectedCallback() {
        this.abortController.abort();
        this.io.disconnect();
      }
    }

    customElements.define('full-width-media', FullWidthMedia);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-form"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.form = this.querySelector('form');

        document.addEventListener('pdp:product-change', this.onProductChange.bind(this), {
          signal: this.abortController.signal
        });
        document.addEventListener('pdp:variant-change', this.onVariantChange.bind(this), {
          signal: this.abortController.signal
        });
        if(this.form) {
          this.openCart = this.form.dataset.openCart != 'false';
          this.form.addEventListener('submit', this.onFormSubmit.bind(this), {
            signal: this.abortController.signal
          })
        }
      }

      onFormSubmit(evt) {
        if(window.storeModule) {
          const id = this.querySelector('[name="id"]').value;
          evt.preventDefault();

          window.storeModule.dispatch('addItems', {
            [id]: 1,
          },  this.openCart)
        }
      }

      onProductChange(evt) {
        const product = evt.detail.product;
        const currentUrl = new URL(document.location.href);
        const productIdInput = this.querySelector('[name="product-id"]');

        currentUrl.pathname = currentUrl.pathname.replace(/(?:^|\/)products\/([^/]+)(?:$|\/)/g, product.url);
        productIdInput.value = product.id;

        history.replaceState(null, null, currentUrl.toString());
      }

      onVariantChange(evt) {
        const variant = evt.detail.variant;
        const currentUrl = new URL(document.location.href);

        if(variant) {
          currentUrl.searchParams.set('variant', variant.id);
        } else {
          currentUrl.searchParams.delete('variant');
        }

        history.replaceState(null, null, currentUrl.toString());
      }

      disconnectedCallback() {
        this.abortController.abort()
      }
    }

    customElements.define('product-form', ProductForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-options')) {
    class ProductOptions extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const productJsonData = this.querySelector('[data-product-json]');
        const combinedListingsData = this.querySelector('[data-combined-listings]');
        const productSwatchesImages = this.querySelector('[data-swatches-images]')?.innerHTML;

        if(!productJsonData) return;

        if(productJsonData) {
          this.productJson = JSON.parse(productJsonData.innerHTML);
        }

        if(combinedListingsData) {
          this.combinedListings = JSON.parse(combinedListingsData.innerHTML);
        }

        if(productSwatchesImages && productSwatchesImages.trim() != "") {
          this.productSwatches = JSON.parse(productSwatchesImages);
        }

        this.idSelector = this.querySelector('input[name="id"]');
        this.abortController = new AbortController();
        this.addEventListener('change', this.onOptionChange.bind(this), {
          signal: this.abortController.signal
        })

        this.addEventListener('pointerover', this.onMouseOver.bind(this), {
          signal: this.abortController.signal
        });

        this.addEventListener('pointerout', this.onMouseLeave.bind(this), {
          signal: this.abortController.signal
        });

        this.addEventListener('product-option:error', this.onErrorTrigger.bind(this), {
          signal: this.abortController.signal
        })

        this.onProductChange();
        this.onVariantChange();
      }

      onMouseOver(evt) {
        if(this.dataset.disableHover || evt.pointerType == 'touch') return;

        if(evt.target.classList.contains('product-options__input') && evt.target.name.toLowerCase() == 'color') {

          if(this.hoverTimeout) {
            clearTimeout(this.hoverTimeout);
          }

          const productInfo = this.combinedListings[evt.target.value];

          evt.target.closest('fieldset').querySelector('[data-current-value]').innerText = evt.target.value;

          this.dispatchEvent(new CustomEvent('pdp:swatch-enter', {
            detail: {
              product: productInfo
            },
            bubbles: true
          }));
        }
      }

      onMouseLeave(evt) {
        if(this.dataset.disableHover || evt.pointerType == 'touch') return;

        if(evt.target.classList.contains('product-options__input') && evt.target.name.toLowerCase() == 'color') {
          this.hoverTimeout = setTimeout(() => {
            this.dispatchEvent(new CustomEvent('pdp:swatch-leave', {
              bubbles: true,
            }))

            evt.target.closest('fieldset').querySelector('[data-current-value]').innerText = this.currentVariant[evt.target.dataset.optionKey];
          }, 300)
        }
      }

      onErrorTrigger(evt) {
        const optionContainer = evt.target.closest('.product-options__fieldset');

        optionContainer.classList.add('has-error');
      }

      onOptionChange(evt) {
        const optionContainer = evt.target.closest('.product-options__fieldset');
        const optionLabel = optionContainer.querySelector('[data-current-value]');

        optionLabel.innerText = evt.target.value;
        optionContainer.classList.remove('has-error');

        if(evt.target.name.toLowerCase() == 'color') {
          this.onProductChange.call(this, evt);
        } else {
          this.onVariantChange.call(this,evt);
        }
      }

      onProductChange(evt) {
        if(evt) {
          this.productJson = this.combinedListings[evt.target.value];
        }

        this.updateOtherOptions()

        this.dispatchEvent(new CustomEvent('pdp:product-change', {
          bubbles: true,
          detail: {
            product: this.productJson
          }
        }))

        this.onVariantChange();
      }

      getOptionValuesFromVariants() {
        const uniqueValues = {
          option1: new Set(),
          option2: new Set(),
          option3: new Set()
        }

        this.productJson.variants.forEach(variant => {
          if(variant.option1) {
            uniqueValues.option1.add(variant.option1);
          }
          if(variant.option2) {
            uniqueValues.option2.add(variant.option2);
          }
          if(variant.option3) {
            uniqueValues.option3.add(variant.option3);
          }
        });

        return uniqueValues;
      }

      updateOtherOptions() {
        const productOptions = this.getOptionValuesFromVariants();

        this.productJson.options.forEach((option, index) => {
          const optionPosition = index + 1;
          const optionContainer = this.querySelector(`[data-option="${option.name.toLowerCase()}"]`);
          const optionValuesContainer = optionContainer.querySelector('[data-option-values]');
          const currentValue = optionContainer.querySelector('[data-current-value]');

          const optionKey = `option${index+1}`;

          const sortedOptions = Array.from(productOptions[optionKey]).sort((a, b) => {
            if(!isNaN(a) && !isNaN(b)) {
              return a-b;
            } else {
              return 1;
            }
          })

          const newOptions = sortedOptions.map((value, valIndex) => {
            if(option.name.toLowerCase() == 'color' || option.name.toLowerCase() == "colour") {
              const swatch = this.productSwatches[value];
              const productAvailable = this.combinedListings[value].available ?? false;

              return `
                <label class="product-options__swatch ${!productAvailable ? 'product-options__swatch--sold-out':''}">
                  <input
                    type="radio"
                    class="product-options__input product-options__input--swatch"
                    name="${option.name}"
                    value="${value}"
                    data-option-key="option${optionPosition}"
                    ${currentValue.innerText == value ? 'checked="true"' : ''}
                  >
                  <span class="product-options__swatch-ui">
                    <img src="${swatch.src}" alt="${swatch.alt || ""}" loading="eager" width="28px;">
                  </span>
                  <div class="product-options__swatch-label">
                    ${value}
                  </div>
                </label>
              `
            } else {
              return `
                <label class="product-options__button">
                  <input
                    type="radio"
                    class="product-options__input product-options__input--button"
                    name="${option.name}"
                    value="${value}"
                    data-option-key="option${optionPosition}"
                    ${currentValue.innerText == value ? 'checked="true"' : ''}
                  >
                  <span class="product-options__button-ui">
                    ${value}
                  </span>
                </label>
              `
            }
          });

          optionValuesContainer.innerHTML = newOptions.join('');
        })

        this.updateAvailableOptions();
      }

      onVariantChange(evt){
        this.updateOtherOptions();

        this.dispatchEvent(new CustomEvent('pdp:variant-change', {
          bubbles: true,
          detail: {
            variant: this.currentVariant
          }
        }))

        if(this.currentVariant) {
          this.idSelector.value = this.currentVariant.id;
        } else {
          this.idSelector.value = "";
        }

        this.updateLowInventoryThreshold();
      }

      updateAvailableOptions() {
        const availableOptions = this.getAvailableOptions();
        const productOptions = this.querySelectorAll('input[type="radio"]');
        const currentValueList = Array.from(this.querySelectorAll("[data-current-value]"));
        const selectedValues = currentValueList.filter(value => value.innerText.trim() !== '');
        const fullSelection = selectedValues.length == currentValueList.length;


        productOptions.forEach(option => {
          const optionKey = option.dataset.optionKey;
          const optionValue = option.value;

          if(!fullSelection && optionKey == 'option1') return;

          if(availableOptions[optionKey].has(optionValue)) {
            option.removeAttribute('data-disabled');
          } else {
            option.setAttribute('data-disabled', true);
          }
        })
      }

      updateLowInventoryThreshold() {
        const lowInventoryMessageContainer = this.querySelector('[data-low-stock-message]');
        if(lowInventoryMessageContainer && this.currentVariant) {
          const message = lowInventoryMessageContainer.dataset.lowStockMessage;
          const threshold = lowInventoryMessageContainer.dataset.threshold;
          if(this.currentVariant.available && this.currentVariant.inventory <= threshold) {
            lowInventoryMessageContainer.innerText = message.replace('[quantity]', this.currentVariant.inventory);
            lowInventoryMessageContainer.classList.remove('hidden');
          } else {
            lowInventoryMessageContainer.innerText = "";
            lowInventoryMessageContainer.classList.add('hidden');
          }
        }

      }

      getAvailableOptions() {
        const optionValues = Array.from(this.querySelectorAll('[data-current-value]'));
        const selectedValues = optionValues.map(option => option.innerText);
        let activeVariant = null;

        const optionMap = {
          option1: new Set(),
          option2: new Set(),
          option3: new Set(),
        }

        const enabledMap = {
          option1: new Set(),
          option2: new Set(),
          option3: new Set(),
        }

        this.productJson.variants.forEach(variant => {
          if(variant && variant.option1) optionMap.option1.add(variant.option1);
          if(variant && variant.option2) optionMap.option2.add(variant.option2);
          if(variant && variant.option3) optionMap.option3.add(variant.option3);

          if(variant.options.join(' ') == selectedValues.join(' ')) {
            activeVariant = variant;
          }
        });

        ['option1', 'option2', 'option3'].forEach((optionKey) => {

          if(optionMap[optionKey].size === 0) return;

          for(const optionValue of (optionMap[optionKey])) {
            const testSelection = {
              option1: selectedValues[0],
              option2: selectedValues[1],
              option3: selectedValues[2],
            }

            testSelection[optionKey] = optionValue;

            const matchingVariant = this.productJson.variants.find(loopVariant =>
              (!testSelection.option1 || loopVariant.option1 === testSelection.option1) &&
              (!testSelection.option2 || loopVariant.option2 === testSelection.option2) &&
              (!testSelection.option3 || loopVariant.option3 === testSelection.option3)
            )

            if(matchingVariant && matchingVariant.available) {
              enabledMap[optionKey].add(optionValue);
            }
          }
        })

        this.currentVariant = activeVariant;

        return enabledMap;
      }
      disconnectedCallback() {
        this.abortController.abort();
      }
    }
    customElements.define('product-options', ProductOptions);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-price"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('product-price')) {
    class ProductPrice extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.comparePriceContainer = this.querySelector('[data-compare-price]');
        this.comparePriceValue = this.comparePriceContainer.querySelector('[data-value]');
        this.priceValue = this.querySelector('[data-full-price] [data-value]');
        this.discountValue = this.querySelector('[data-discount-value]');

        document.addEventListener('pdp:product-change', this.onProductChange.bind(this), {
          signal: this.abortController.signal
        })
        document.addEventListener('pdp:variant-change', this.onVariantChange.bind(this), {
          signal: this.abortController.signal
        });
        this.addEventListener('pdp:variant-change', this.onVariantChange.bind(this), {
          signal: this.abortController.signal
        })

        this.updateDiscount();
      }

      onProductChange(evt) {
        const product = evt.detail.product;
        this.discountValue.setAttribute('data-product-collections', product.collections.join(','));
      }

      onVariantChange(evt) {
        const variant = evt.detail.variant;
        if(variant) {
          this.style.display = "block";
          this.priceValue.innerText = Shopify.formatMoney(variant.price, window.Shopify.money_format.replace(/\{\{\s*(\w+)\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}'));

          if(variant?.compare_at_price && variant.compare_at_price > variant.price) {
            this.comparePriceValue.innerText = Shopify.formatMoney(variant.compare_at_price, window.Shopify.money_format.replace(/\{\{\s*(\w+)\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}'));
            this.comparePriceContainer.classList.remove('hidden');
          } else {
            this.comparePriceValue.innerText = "";
            this.comparePriceContainer.classList.add('hidden');
          }
          this.updateDiscount(variant);
        } else {
          this.style.display = 'none';
        }
      }

      updateDiscount(variant) {
        // Check for custom discount messages
        if(window.promoMessages.length > 0) {
          const promoObject = window.promoMessages.find((messageObject) => {
            return this.discountValue.dataset.productCollections.includes(messageObject.allowedCollection);
          })

          if(promoObject.promoMessage) {
            this.discountValue.innerText = promoObject.promoMessage;
            this.discountValue.classList.remove('hidden');
            return;
          }
        }

        // Check for automated discount module discount message
        const discountMessage = sessionStorage.getItem('discountMessage');
        const allowedCollection = sessionStorage.getItem('applicableCollection');
        const applicableProduct = this.discountValue.dataset.productCollections.includes(allowedCollection);

        if(applicableProduct && discountMessage) {
          this.discountValue.innerText = discountMessage;
          this.discountValue.classList.remove('hidden');
          return;
        }

        if(!variant) return;

        if(variant.compare_at_price && variant.compare_at_price > variant.price) {
          const difference = variant.compare_at_price - variant.price;
          const discountValue = difference * 100 / variant.compare_at_price;

          this.discountValue.innerText = `${Math.round(discountValue)}% off`;
          this.discountValue.classList.remove('hidden');
        } else {
          this.discountValue.classList.add('hidden');
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
    customElements.define('product-price', ProductPrice)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scroll-indicator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ScrollIndicator')) {
    class ScrollIndicator extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.button = this.querySelector('button');

        this.button.addEventListener('click', this.onIndicatorClick.bind(this), {
          signal: this.abortController.signal,
        });
      }

      onIndicatorClick(evt) {
        const currentSection = this.closest('.shopify-section');
        const mainContainer = document.querySelector('main');
        const currentSectionIndex = Array.from(mainContainer.children).findIndex(
          (loopSection) => loopSection == currentSection
        );
        let target = null;

        if (this.dataset.target != undefined) {
          target = document.querySelector(this.dataset.target);
        } else {
          target = Array.from(mainContainer.children)[currentSectionIndex + 1];
        }

        this.scrollToTarget(target);
      }

      scrollToTarget(target) {
        const offset = target.offsetTop;
        const headerHeight = document.documentElement.style.getPropertyValue('--header-height').replace('px', '');

        window.scrollTo({
          top: offset - headerHeight,
          behavior: "smooth"
        })
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('scroll-indicator', ScrollIndicator);
  }
  } catch(e) { console.error(e); }
})();

})();
